import { getValidatedCustomView } from "c8-platform";
import csiAction from "csi/action";
import Action from "csi/def/Action";
import csi from "csi/main";
import { canShowAttribute } from "csi/service/businessObjectService";
import { FILTER_ATTRIBUTES_CONTAINER_URL, getFilterAttributesUrlForType } from "csi/service/filterAttributeService";
import { getAttributeCardSpecsForType, getClassEmptyPropertyView } from "csi/service/viewService";
import AggregateFrom from "csi/table/AggregateFrom";
import csiView from "csi/view";
import declare from "dojo/_base/declare";
import BusinessObject from "../BusinessObject";

const FilterAttributesController = declare(AggregateFrom, {
	/**
	 * @override
	 * Invoke manage attributes controller action to popup Attributes dialog.
	*/
	async preProcess(): Promise<void> {
		const { widget } = this;
		const rc = BusinessObject.getAttributeClass(widget.getViewNode());
		const typeClass = rc.getType();
		const urlCustomViewContainer = FILTER_ATTRIBUTES_CONTAINER_URL;
		const urlCustomView = getFilterAttributesUrlForType(typeClass);
		const customView = await getValidatedCustomView(urlCustomView);
		const cardSpecs = getAttributeCardSpecsForType(typeClass, customView);
		const attributeKeys = cardSpecs.attributeSpecs.map((spec) => spec.key.typedString);
		const defView = getClassEmptyPropertyView(rc);
		const viewWithAttributes = csiView.newView(defView, null, {
			attributeKeys,
			disableCustomViewToolbar: true,
			displayPropertyImage: false,
			plugins: [],
			propertyColumns: 2,
			supportsCustomViews: () => true,
			urlDefaultView: csi.EMPTY_URL,
		});

		// TODO: do not need drag-and drop reordering in attribute picker - instead sort alphabetically (although not sure if should sort by path)
		// but may not be a priority

		const action = Object.assign(new Action(), {
			m_id: "FilterAttributesEdit",
			m_postAction: () => widget.viewParent.redraw(),
			classController: "csi/prefs/ManageAttributesController",
			classControllerParams: {
				canShowAttribute,
				urlCustomView,
				urlCustomViewContainer,
				viewWithAttributes,
			},
		});

		csiAction.invoke(widget, null, action);

		this.suspendProcess();
	},
});

export = FilterAttributesController;